
const Products = () => {
  
  ;
    return <><div className="Compass"><p>/Products/general information</p></div>
    
    <div className="pp">
            <section className="product-section">
        <h3>Comprehensive Medical Equipment Range</h3>
        <p>From diagnostic equipment to surgical instruments, we offer a complete range of medical devices from world-renowned manufacturers.</p>
         <div className="product-section2">
            
 <div className="product-description"> 
        <img src="KitsForRespons.jpg" alt="Product-img"></img> 
            <h2>Laboratory analyzers</h2>
            <p>Laboratory analyzers, testing devices, and precision equipment.</p>
            <a href= "/productsInfo" className="b1">more</a>
        </div>
        <div className="product-description">
        <img    src="BioBaseRefrigerator.jpg" alt="Product-img"  ></img> 
            <h2>Laboratory equipment</h2>
            <p>Refrigerators, incubators, and controlled storage solutions.</p>
            <a href="/Contaiment" className="b1">more</a>
        </div>
        
        <div className="product-description">
        <img    src="D3.jpg" alt="Product-img"></img> 
            <h2>Medicine & Consumables</h2>
            <p>Certified pharmaceuticals and everyday medical supplies.</p>
           
            <a href="/MedicineInfo" className="b1">more</a>
        </div>
        
        </div>
        
           
       
    

        
    </section>
    <div className="up-coming">
        <h3 className="up">Up coming </h3>

        <div className="hot"><div className="hot-1">
        
        </div>
         <h3>Truenat systems
            <span className="tag">Molbio</span>
         </h3>
          <p>Truelab® Duo Real Time Quantitative micro PCR Analyzer <strong>-</strong>Trueprep® AUTO v2 Universal Cartridge Based Sample Prep Device <strong>-</strong>Truenat® Disease Specific Real Time micro PCR Chips   </p>
          <div className="hot-images">
            <img src="TrueNat-systems.jpg"  alt="" />
          </div>
        </div>
        <div className="new"><div className="new-1">
        
      </div>
       <h3>TTelemedicine Monitor HES-7 <span className="tag">Konsung</span>
       </h3>
        <p><strong>Mean parameters</strong>ECG-,HR , SPO2, PR, NIBP, TEMP, Urine,<strong>-</strong>Optiional  Glucose, Blood Lipid, WBC, Hemoglobin , UA,CRP, HbA1c, Liver function, Kidney function , Lung function , Weight, Vitamin D , Ultrasound-stethoscope  </p>
        <div className="new-images">
            <img src="KonsungMonitor-HES7.jpg" alt=""  width={400} height={400}/> <img src="KonsungMonitorWithAccessory.jpg" alt="" width={400} height={400}></img> <img src="konsung-1-monitor.jpg" alt=""  width={400} height={400}/>
        </div>
        
          
      </div>
      </div>
  
    
       
      </div></>;
  };
  
  export default Products;